import { Subject, fromEvent } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
  SimpleChanges,
  OnChanges,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  OnDestroy
} from '@angular/core';
import { PhxBackground } from '../../../types';
import { PhxCardWidth } from '../card-base/phx-card-base.types';
import { enableBodyScroll, disableBodyScroll } from '../../../utils';
import { isMobileView } from '../../../screen-sizes/utils';
@Component({
  selector: 'phx-form-card',
  styleUrls: ['./phx-form-card.scss'],
  templateUrl: './phx-form-card.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-form-card',
    '[class.phx-edit-mode]': `phxEditMode`,
  },
})
export class PhxFormCardComponent implements OnChanges, OnDestroy {
  @Input() public phxEditMode: boolean = false;
  @Input() public phxWidth: PhxCardWidth = 'default';
  @Input() public phxNewHeaderEnabled: boolean = false;
  @Output() public phxHeaderBackgroundChange: EventEmitter<PhxBackground> = new EventEmitter<PhxBackground>();
  
  public isMobile: boolean = isMobileView();
  public onDestroy$: Subject<void> = new Subject<void>();
  
  constructor(private _cdr: ChangeDetectorRef) {
    this.emitBackground(this.phxEditMode);
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(200),
        takeUntil(this.onDestroy$)
      )
      .subscribe({
        next: this.onResize.bind(this),
        error: null
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { phxEditMode } = changes;
    if (phxEditMode) {
      this.emitBackground(phxEditMode.currentValue);

      if (phxEditMode.currentValue === true) this.setBodyScrollInEditMode();
      else if (phxEditMode.currentValue === false) enableBodyScroll();

      this._cdr.markForCheck();
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  private emitBackground(editMode: boolean): void {
    this.phxHeaderBackgroundChange.emit(editMode ? 'bold' : 'standard');
  }

  private setBodyScrollInEditMode(): void {
    if (this.isMobile) disableBodyScroll();
    else enableBodyScroll();
  }

  private onResize(): void {
    const oldIsMobile: boolean = this.isMobile;
    this.isMobile = isMobileView();
    if (this.isMobile != oldIsMobile) {
      this._cdr.markForCheck();
      if (this.phxEditMode) this.setBodyScrollInEditMode();
    }
  }
}

